import React from "react";

import { Alert } from "react-bootstrap";

const WaitingBox = ({ text, variant }) => {
  return (
    <Alert key={variant} variant={variant}>
      {text}
    </Alert>
  );
};

export default WaitingBox;
